import React from 'react';
import Header from './components/Header';
import Profile from './components/Profile';
import LinkList from './components/LinkList';
import Footer from './components/Footer';
import './App.css';
import styled from 'styled-components';
import LinkListWithDiscordHelper from './components/LinkLinkWithDiscordHelper';

// Kontener aplikacji
const AppContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

// Nowy komponent BackgroundImage zamiast BackgroundVideo
const BackgroundImage = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -2;
  transform: translate(-50%, -50%);
  background-image: url('/background.jpg'); /* Ścieżka do Twojego obrazu */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

// Nakładka przyciemnienia
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5); /* Ciemna nakładka */
  z-index: -1;
`;

// Treść aplikacji
const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: white; /* Kolor tekstu dla lepszej widoczności */
`;

function App() {
  return (
    <AppContainer>
      {/* Element obrazu jako tło */}
      <BackgroundImage />
      
      {/* Nakładka przyciemnienia */}
      <Overlay />
      
      {/* Treść aplikacji */}
      <Content>
        <Header />
        <Profile />
        <LinkListWithDiscordHelper discordInvite='https://discord.gg/5dt3gCNE2A' />
        <Footer />
      </Content>
    </AppContainer>
  );
}

export default App;